module.exports = __webpack_public_path__ + "img/card_cover.14edfc39.png";